import React from "react";
import themePropTypes from "../theme-prop-types";

const MessageHeader = ({
  data: { header_title, header_subtitle },
  headerDetails
}) => (
  <div className='message-wrapper-web-sdk'>
    <div className='message-header-web-sdk'>
      {`${header_title} ${header_subtitle}`}
    </div>
    <div className='message-body-web-sdk'>{headerDetails}</div>
  </div>
);

MessageHeader.propTypes = themePropTypes.messageHeader;

export default MessageHeader;
